import { render, staticRenderFns } from "./ModalTutoKeep.vue?vue&type=template&id=133062e3&scoped=true&"
import script from "./ModalTutoKeep.vue?vue&type=script&lang=js&"
export * from "./ModalTutoKeep.vue?vue&type=script&lang=js&"
import style0 from "./ModalTutoKeep.vue?vue&type=style&index=0&id=133062e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133062e3",
  null
  
)

component.options.__file = "ModalTutoKeep.vue"
export default component.exports